import React from 'react';
import { Plus, Minus, Trash } from 'lucide-react';
import { formatCurrency } from '../utils/helpers';

const CartItem = ({ item, onUpdateQuantity, onRemoveItem }) => {
  const handleIncrement = () => {
    onUpdateQuantity(item.cartItemId, item.quantity + 0.5);
  };

  const handleDecrement = () => {
    onUpdateQuantity(item.cartItemId, Math.max(0.5, item.quantity - 0.5));
  };

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center bg-white p-4 rounded-xl shadow-sm border border-gray-100 gap-3">
      <img
        src={item.image}
        alt={item.name}
        className="w-20 h-20 sm:w-16 sm:h-16 object-cover rounded-lg mr-0 sm:mr-4 flex-shrink-0"
      />
      <div className="flex-grow w-full">
        <h4 className="font-semibold text-gray-900 text-lg sm:text-base">{item.name}</h4>
        <p className="text-sm text-gray-600">
          {formatCurrency(item.pricePerPound)}/lb
        </p>
        <p className="text-sm font-bold text-blue-600">
          Total: {formatCurrency(item.pricePerPound * item.quantity)}
        </p>
      </div>
      <div className="flex items-center gap-2 w-full sm:w-auto justify-between sm:justify-start mt-2 sm:mt-0">
        <div className="flex items-center border border-gray-300 rounded-lg">
          <button
            onClick={handleDecrement}
            className="p-1 text-gray-600 hover:bg-gray-100 rounded-l-lg"
          >
            <Minus className="w-4 h-4" />
          </button>
          <span className="w-10 text-center text-gray-800 font-medium">
            {item.quantity.toFixed(1)} lb
          </span>
          <button
            onClick={handleIncrement}
            className="p-1 text-gray-600 hover:bg-gray-100 rounded-r-lg"
          >
            <Plus className="w-4 h-4" />
          </button>
        </div>
        <button
          onClick={() => onRemoveItem(item.cartItemId)}
          className="p-2 bg-red-100 text-red-600 rounded-lg hover:bg-red-200"
        >
          <Trash className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default CartItem;